import BreadCrumbs from "../../../components/BreadCrumb.vue";
import iColumn from "../../../components/Column.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import iTerminal from '../../../components/TerminalTable.vue'
import { domainName, processFile } from "../../../utility/index"

export default {
    name: "OTAManagement",
    components: { BreadCrumbs, iColumn, iTable, IPagination, iTerminal },
    data() {
        return {
            dialogVisible: false,
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "typeIdStr",
                    label: this.$t('OTAManagement.typeIdStr'),
                    align: "center",
                    width: "200px"
                },
                {
                    prop: "firmwareVersion",
                    label: this.$t('OTAManagement.firmwareVersion'),
                    align: "center",
                    width: "200px"
                },
                {
                    prop: "defaultVersionStr",
                    label: this.$t('OTAManagement.defaultVersion'),
                    align: "center",
                    width: "180px"
                },
                {
                    prop: "createTime",
                    label: this.$t('OTAManagement.createTime'),
                    align: "center",
                    width: "180px"
                },
                {
                    prop: "updateTime",
                    label: this.$t('OTAManagement.updateTime'),
                    align: "center",
                    width: "180px"
                },
                {
                    prop: "lastUser",
                    label: this.$t('OTAManagement.lastUser'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "describe",
                    label: this.$t('OTAManagement.describe'),
                    align: "center",
                },
                {
                    prop: 'state',
                    label: this.$t('OTAManagement.state'),
                    align: 'center',
                    width: "120px",
                    render: (h, params) => {
                        if (params.row.state == 0) {
                            return h('el-button',
                                {
                                    props: {
                                        type: 'text', size: 'small',
                                    },
                                    style: { display: params.row.state == 1 ? 'none' : 'inline-block' },
                                    on: {
                                        click: () => {
                                            this.releases(params.row)
                                        }
                                    }
                                }, this.$t('OTAManagement.issue'))
                        } else {
                            return h('el-button',
                                {
                                    props: {
                                        type: 'text', size: 'small',
                                    },
                                    style: { display: params.row.state == 0 ? 'none' : 'inline-block' },
                                    on: {
                                        click: () => {
                                            this.cancelRelease(params.row)
                                        }
                                    }
                                }, this.$t('OTAManagement.unpublish'))
                        }
                    }
                }
            ],
            operates: {
                width: 60,
                fixed: "right",
                list: [
                ],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            dialogFormVisible: false,
            formLabelWidth: '110px',
            diaTitle: '',
            btnType: '',
            rules: {
                no: [
                    { required: true, message: this.$t('OTAManagement.form.no'), trigger: 'blur' },
                ],
                uploadFile: [
                    { required: true, message: this.$t('OTAManagement.form.uploadFile'), trigger: 'blur' },
                ],
                groupId: [
                    { required: true, message: this.$t('OTAManagement.form.groupId'), trigger: 'change' }
                ],
                typeId: [
                    { required: true, message: this.$t('OTAManagement.form.typeId'), trigger: 'change' }
                ]
            },
            form: {
                no: '',
                uploadFile: '',
                groupId: '0',
                carIds: '',
                carId: '',
                describe: '',
                typeId: '',
                defaultVersion: ''
            },
            roleId: '',
            selected: [],
            FileList: [],
            processFile: processFile,
            groupStatus: true,
            upload: {},
            dialogVisibleTransfer: false,
            delTransfer: true,
            terminalList: [],
            paramsData: null
        };
    },
    created() {
        this.getTerminalType()
    },
    mounted() {
        this.getOTA()
    },
    methods: {
        getTerminalType() {
            this.$store.dispatch('TerminalCommand/GET_TERMINALTYPE', {}).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.terminalList = res.data.data
                    }
                }
            }).catch(err => { })
        },
        getNewCarInfo() {
            this.dialogVisibleTransfer = true
            this.delTransfer = false
            this.$nextTick(() => {
                this.delTransfer = true

            })

        },
        indexSelect() {
            this.paramsData = this.form.typeId
        },
        getOTA() {
            let param = {
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }
            this.$store.dispatch('OTAManagement/GET_QUERYOTA', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            })
        },
        handleSelectionChange(val) {
            this.selected = val
            console.log(val)
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getOTA();
        },
        addOTA() {
            this.dialogFormVisible = true;
            this.diaTitle = this.$t('common.btn.add')
            this.btnType = 'add'
            this.$nextTick(() => {
                this.$refs.form.resetFields();
                this.form.describe = ''
                this.form.typeId = ''
            })
        },
        editOTA() {
            this.dialogFormVisible = true;
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'edit'
            this.form.typeId = this.selected[0].typeId === 0 ? '' : this.selected[0].typeId
            this.indexSelect()
            this.form.no = this.selected[0].firmwareVersion
            this.form.describe = this.selected[0].describe
            this.form.carIds = this.selected[0].terminalIdList
            this.form.defaultVersion = this.selected[0].defaultVersion
            if(this.selected[0].defaultVersion == 1) {
                this.form.defaultVersion = true
              }else {
                this.form.defaultVersion = false
              }
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
            })

        },
        changeStatus(val) {
            if (val == 0) {
                this.groupStatus = true
            } else {
                this.groupStatus = false
            }
        },

        uploadFile(e) {
            let dom = document.getElementById('uploadDom')
            let file = dom.files[0];
            this.upload = file
            this.$nextTick(() => {
                this.$refs["formName"].clearValidate("uploadFile")
            })
            this.rules.uploadFile = []
            
        },
        handleSuccess(res, file) {

            const arr = []
            this.FileList.push({
                name: res.name,
                url: res.data,
                uid: res.uid
            })

            this.FileList.map(item => {
                arr.push(item.url)
            })
            this.form.carIds = arr.join(',')
        },
        handleRemove(file, fileList) {
            this.FileList = []
            const arr = []
            fileList.map(item => {
                this.FileList.push({
                    name: item.name,
                    url: item.url,
                    uid: item.uid
                })
                arr.push(item.url)
            })
            this.form.carIds = arr.join(',')
        },
        handlePreview(file) {

        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let formData = new FormData()
                    formData.append('typeId', this.form.typeId)
                    formData.append('no', this.form.no)
                    formData.append('terminalIdList', this.form.carIds)
                    formData.append('describe', this.form.describe)
                    formData.append('OTAFile', this.upload)
                    formData.append('defaultVersion', Number(this.form.defaultVersion))
                    if (this.btnType == 'add') {
                        this.$store.dispatch('OTAManagement/GET_INSERTOTA', formData).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.addSuccess'))
                                this.dialogFormVisible = false;
                                this.getOTA();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    } else {
                        let formDataUpdate = new FormData()
                        formDataUpdate.append('id', this.selected[0].id)
                        formDataUpdate.append('typeId', this.form.typeId)
                        formDataUpdate.append('terminalIdList', this.form.carIds)
                        formDataUpdate.append('describe', this.form.describe)
                        formDataUpdate.append('firmwareVersion', this.form.no)
                        // formDataUpdate.append('OTAFile', this.upload)
                        formDataUpdate.append('defaultVersion', Number(this.form.defaultVersion))
                        this.$store.dispatch('OTAManagement/GET_UPDATEOTA', formDataUpdate).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.editSuccess'))
                                this.dialogFormVisible = false;
                                this.getOTA();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }



                } else {
                    return false;
                }
            });
        },
        postParam(item) {
            if (item.length > 0) {
                item.map((t, index) => {
                    if (index == 0) {
                        this.checkList = t.terminalId
                    } else {
                        this.checkList = this.checkList + ',' + t.terminalId
                    }
                })
            } else {
                this.checkList = ''
            }
        },

        assignment() {
            this.form.carIds = this.checkList
            this.dialogVisibleTransfer = false
        },
        handleClose() {
            this.dialogVisibleTransfer = false
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                no: '',
                groupId: '0',
                carIds: '',
                describe: '',
                typeId: '',
                defaultVersion: ''
            }
            if (this.btnType == 'add') {
                document.getElementById('uploadDom').value = ''

            }
        },
        closeDia() {
            this.$nextTick(() => {
                this.paramsData = null
                this.form = {
                    no: '',
                    groupId: '0',
                    carIds: '',
                    describe: '',
                    typeId: '',
                    defaultVersion: ''
                }
                if (this.btnType == 'add') {
                    document.getElementById('uploadDom').value = ''

                }
            })
            this.dialogFormVisible = false;
        },
        deleteOTA() {
            this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
                {
                    cancelButtonText: this.$t('common.btn.cancel'),
                    confirmButtonText: this.$t('common.btn.confirm'),
                    type: 'warning'
                }).then(res => {
                    let param = { id: this.selected[0].id }
                    this.$store.dispatch('OTAManagement/GET_DELETEOTA', param).then(response => {
                        if (response.data.code == 200) {
                            this.getOTA()
                            this.$message.success(this.$t('common.btn.deleteSuccess'))
                        } else {
                            this.$message.error(response.data.msg)
                        }
                    }).catch(error => { })
                }).catch(err => {

                })
        },
        releases(row) {
            this.$confirm(this.$t('OTAManagement.isConfirmIssue'), this.$t('common.btn.hint'), {
                confirmButtonText: this.$t('common.btn.confirm'),
                cancelButtonText: this.$t('common.btn.cancel'),
                type: 'warning'
            }).then(res => {
                this.$store.dispatch('OTAManagement/GET_PUBLISHOTA', { id: row.id }).then(res => {
                    if (res) {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('OTAManagement.issueSuccess'))
                            this.getOTA()
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    }
                }).catch(err => { })
            }).catch(err => { })
        },
        cancelRelease(row) {
            console.log(row)
            this.$confirm(this.$t('OTAManagement.isConfirmCancelIssue'), this.$t('common.btn.hint'), {
                confirmButtonText: this.$t('common.btn.confirm'),
                cancelButtonText: this.$t('common.btn.cancel'),
                type: 'warning'
            }).then(res => {
                this.$store.dispatch('OTAManagement/GET_CANCELOTA', { id: row.id }).then(res => {
                    if (res) {
                        if (res.data.code == 200) {
                            this.$message.success(this.$t('OTAManagement.cancelIssueSuccess'))
                            this.getOTA()
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    }
                }).catch(err => { })
            }).catch(err => { })
        },
        BulkImport() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportContractModel`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportContractModel`
                    location.href = url
                }
            }
        },

        changeSort(item) {
            this.columns = [];
            this.$nextTick(function () {
                this.columns = item;
            });
        },

        ListSetting() {
            this.$refs.listSet.dialogVisible = true;
        },
    },
};
